<template>
	<div class="mobile">
		<div class="top-bar" :class="{'top-bar-bg': istopBgShow && !isNavShow}">
			<img class="logo" src="../assets/images/logo.png" />
			<div @click="closeNav()" class="close" v-if="isNavShow"></div>
			<div @click="openNav()" class="nav" v-else></div>
		</div>
		<div class="page-1" id='page-1'>
			<div class="btn" @click="showCode()">定制计划</div>
			<h2>我们是挑剔的补充剂品鉴师</h2>
			<p>养研360品鉴体系</p>
			<div class="tip">
				<span>下滑了解详情</span>
				<img src="../assets/images/down_arrow.png" />
			</div>
		</div>

		<div class="page-2" id='page-2'>
			<div class="title">养研360品鉴体系</div>
			<div class="list">
				<div class="item">
					<h2>严格的标准</h2>
					<p>独特的多维度评价体系<br />品质细节</p>
					<img src="@/assets/images/page_2_pic_1.png" />
				</div>
				<div class="item">
					<h2>严谨的实测</h2>
					<p>第三方独立实验室<br />实测含量和污染数据公开</p>
					<img src="@/assets/images/page_2_pic_2.png" />
				</div>
				<div class="item">
					<h2>严苛的甄选</h2>
					<p>全球范围寻觅<br />最佳剂型和配方</p>
					<img src="@/assets/images/page_2_pic_3.png" />
				</div>
			</div>
			<div class="sub-title">杜绝智商税 选择安心品</div>
			<div class="btn" @click="showCode()">进入选品攻略</div>
		</div>

		<div class="page-3" id='page-3'>
			<div class="title">我们是专业的补充剂规划师</div>
			<div class="list">
				<div class="item">
					<h2>30天抗压活力计划</h2>
					<div class="ball">
						<img src="../assets/images/page_3_pic_1.png" />
					</div>
					<div class="products">
						<img src="../assets/images/page_3_b_pic_1.png" />
					</div>
				</div>
				<div class="item">
					<h2>28天美容睡眠计划</h2>
					<div class="ball">
						<img src="../assets/images/page_3_pic_2.png" />
					</div>
					<div class="products">
						<img src="../assets/images/page_3_b_pic_2.png" />
					</div>
				</div>
				<div class="item">
					<h2>30天骨骼清奇计划</h2>
					<div class="ball">
						<img src="../assets/images/page_3_pic_3.png" />
					</div>
					<div class="products">
						<img src="../assets/images/page_3_b_pic_3.png" />
					</div>
				</div>
			</div>
			<div class="btn" @click="showCode()">制定我的计划</div>
		</div>


		<div class="page-4" id='page-4'>
			<h2>我们是贴心的补充剂课代表</h2>
			<img src="@/assets/images/page_4_pic.png" />
			<p>早餐 VS 睡前？</p>
			<p>随餐 VS 空腹？</p>
			<p>一次几粒？</p>
			<p>一日几顿？</p>
			<p class="sub">养研社全知道</p>

			<div class="btn" @click="showCode()">打卡我的计划</div>
		</div>



		<div class="foot">
			<div class="left">
				<div class="logo"></div>
				<p class="tip">本站建议和产品不能作为任何医学诊断、治疗依据和方法</p>
			</div>
			<div class="right">
				<div class="cell">
					<div class="title">社交媒体</div>
					<ul class="icons">
						<li @click="showWXPop()"><img src="../assets/images/wx.png" /></li>
						<li @click="showRedBookPop()"><img src="../assets/images/xhs.png" /></li>
					</ul>
				</div>
				<!-- <div class="cell">
					<div class="title">加入我们</div>
					<p class="email">
						<a href="mailto:hr@labyouth.com">hr@labyouth.com</a>
					</p>
				</div> -->
				<div class="cell">
					<div class="title">联系我们</div>
					<p class="email">
						<a href="mailto:media@labyouth.com">media@labyouth.com</a>
					</p>
				</div>
			</div>
			<div class="qr">
				<img src="../assets/images/code.jpg" />
				<p>扫码进入微信小程序</p>
			</div>

			<div class="cr">
				<p>All rights reserved LabYouth</p>
				<p><a rel="nofollow" href="http://beian.miit.gov.cn/">沪ICP备2022021755号-1</a></p>
			</div>
		</div>

		<transition name="FadeIn">
			<div class="cover" v-if="coverShow" v-show="coverShow"></div>
		</transition>
		<transition name="BottomIn">
			<div class="code" v-if="isCodeShow" v-show="isCodeShow">
				<img src="../assets/images/code.jpg" />
				<p>扫码进入微信小程序</p>
				<div class="close" @click="hideCode()"></div>
			</div>
		</transition>

		<transition name="BottomIn">
			<div class="code" v-if="isWXPopShow" v-show="isWXPopShow">
				<img src="../assets/images/wxcode.jpeg" />
				<p>微信扫码关注我们</p>
				<div class="close" @click="hideWXPop()"></div>
			</div>
		</transition>
		<transition name="BottomIn">
			<div class="code" v-if="isRedBookPopShow" v-show="isRedBookPopShow">
				<img src="../assets/images/redbookcode.png" />
				<p>小红书扫码关注我们</p>
				<div class="close" @click="hideRedBookPop()"></div>
			</div>
		</transition>

		<transition name="BottomIn">
			<div class="about" v-if="isAboutShow" v-show="isAboutShow">
				<h2>About 养研社</h2>
				<p style="margin-bottom: 20px;">养研社是一个专业的补充剂方案的提供平台。在这里你能找到</p>
				<p style="font-weight: 500;">1. 对的计划</p>
				<p>我们认为没有一种营养能包治百病</p>
				<p style="margin-bottom: 20px;">养研社只根据严谨的临床研究结果，为您定制针对、有效的计划</p>
				<p style="font-weight: 500;">2. 对的产品</p>
				<p>我们认为没有一个品牌能做到全产品线最优品质</p>
				<p style="margin-bottom: 20px;">养研社只甄选各品类中的精品，为您精准选品</p>
				<p style="font-weight: 500;">3. 对的工具</p>
				<p>我们认为错误的时间、剂量都会导致效果不佳</p>
				<p style="margin-bottom: 20px;">养研社为您制定服用计划，时间、剂量一目了然，形成良好习惯</p>
				<h2>About 凯丽</h2>
				<p>养研社Labyouth创始人，中国国家公共营养师</p>
				<p>毕业于复旦大学及美国沃顿商学院</p>
				<p>中美10年医药行业工作后，开始反思健康本源</p>
				<div class="close" @click="hideAbout()"></div>
			</div>
		</transition>

		<div class="nav-box" v-if="isNavShow">
			<ul>
				<li @click="go()"><a href="#page-1">首 页</a></li>
				<li @click="go()"><a href="#page-2">选 品</a></li>
				<li @click="go()"><a href="#page-3">计 划</a></li>
				<li @click="go()"><a href="#page-4">打 卡</a></li>
				<li>
					<div class="line"></div>
				</li>
				<li @click="showAbout()">关 于</li>
			</ul>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				coverShow: false,
				isCodeShow: false,
				isAboutShow: false,
				isNavShow: false,
				istopBgShow: false,
				isWXPopShow: false,
				isRedBookPopShow: false,
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
		computed: {

		},
		watch: {},
		methods: {
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop
				if (scrollTop > 100) {
					this.istopBgShow = true
				} else {
					this.istopBgShow = false
				}
			},
			showCode() {
				this.isCodeShow = true
				this.coverShow = true
			},
			hideCode() {
				this.isCodeShow = false
				this.coverShow = false
			},
			hideAbout() {
				this.isAboutShow = false
				this.coverShow = false
			},
			showAbout() {
				this.isAboutShow = true
				this.coverShow = true
			},
			openNav() {
				this.isNavShow = true
			},
			closeNav() {
				this.isNavShow = false
			},
			go() {
				this.closeNav()
			},
			showWXPop() {
				this.isWXPopShow = true
				this.coverShow = true
			},
			showRedBookPop() {
				this.isRedBookPopShow = true
				this.coverShow = true
			},
			hideWXPop() {
				this.isWXPopShow = false
				this.coverShow = false
			},
			hideRedBookPop() {
				this.isRedBookPopShow = false
				this.coverShow = false
			},
		}
	}
</script>

<style scoped lang="less">
	.mobile {
		font-size: .14rem;
	}

	.nav-box {
		position: fixed;
		z-index: 8;
		background: rgba(255, 255, 255, 0.98);
		width: 100vw;
		height: 100vh;
		left: 0;
		top: 0;

		ul {
			padding-top: 1rem;

			li {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				font-size: .2rem;
				padding: 0.2rem .78rem .2rem 0;

				.line {
					height: 1px;
					width: 2rem;
					background: #e5e5e5;
					margin-right: -0.4rem;
				}

				a {
					color: #000;
				}
			}
		}
	}

	.top-bar {
		width: 100vw;
		position: fixed;
		z-index: 9;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding: 0.24rem 0.3rem;
		box-sizing: border-box;
		transition: all .4s;

		.logo {
			height: 0.36rem;
			width: auto;
			margin-right: .2rem;
		}

		.nav {
			width: .24rem;
			height: .24rem;
			background: url('../assets/images/nav.png') no-repeat;
			background-size: cover;
		}

		.close {
			width: .24rem;
			height: .24rem;
			background: url('../assets/images/close.png') no-repeat;
			background-size: cover;
		}

		&.top-bar-bg {
			background: rgba(255, 255, 255, .5);
			padding: 0.18rem 0.3rem;

			.logo {
				height: 0.24rem;
				width: auto;
				margin-right: .2rem;
			}

			.nav {
				width: .2rem;
				height: .2rem;
			}

			.close {
				width: .2rem;
				height: .2rem;
			}
		}
	}

	.page-1 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
		padding-top: 4rem;
		height: 100vh;
		padding-bottom: 0.3rem;
		box-sizing: border-box;
		background: url('../assets/images/page_1_m_1.png') left 0.8rem no-repeat;
		background-size: 100% auto;

		.btn {
			font-size: .19rem;
			height: .48rem;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: .25rem;
			background: #FDF19D;
			background-image: linear-gradient(left, #FDF19D 0%, #FDF19D 100%);
			padding: 0 .45rem;
			font-weight: 500;
			cursor: pointer;
			margin-bottom: 0.5rem;

			&:active {
				background-image: linear-gradient(left, #CC99EA 0%, #FDF19D 100%);
			}
		}

		h2 {
			font-weight: normal;
			font-size: .24rem;
			margin-bottom: .2rem;
		}

		p {
			font-size: .2rem;
			margin-bottom: .5rem;
		}

		.tip {
			display: flex;
			flex-direction: column;
			align-items: center;

			span {
				margin-bottom: 0.1rem;
			}

			img {
				width: .1rem;
				height: auto;
				-webkit-animation: move 1s infinite;
				-moz-animation: move 1s infinite;
				-ms-animation: move 1s infinite;
				animation: move 1s infinite;
			}

			@keyframes move {
				0% {
					transform: translateY(0px);
				}

				50% {
					transform: translateY(10px);
				}

				100% {
					transform: translateY(0px);
				}
			}
		}
	}

	.foot {
		background: #3B3B3B;
		padding: 0.5rem .4rem;

		.left {
			margin-bottom: 0.4rem;

			.logo {
				width: 1.4rem;
				height: 0.6rem;
				background: url("../assets/images/logo_w.png") no-repeat;
				background-size: contain;
				margin-bottom: .2rem;
			}

			.tip {
				color: rgba(255, 255, 255, 0.5);
				margin-bottom: .08rem;
				font-size: .12rem
			}


		}

		.cr {
			p {
				font-size: .12rem;
				color: rgba(255, 255, 255, 0.5);

				a {
					color: rgba(255, 255, 255, 0.5);
				}
			}
		}

		.right {



			.cell {
				margin-bottom: 0.4rem;

				.title {
					color: #fff;
					font-size: .16rem;
					margin-bottom: .1rem;
				}

				.icons {
					display: flex;

					li {
						margin-right: .15rem;

						img {
							width: .4rem;
							height: auto;
						}
					}
				}

				p {
					color: #C292F4;
					font-size: .16rem;

					a {
						color: #C292F4;
					}
				}
			}

		}

		.qr {
			margin-bottom: .2rem;

			img {
				display: block;
				width: 0.8rem;
				height: auto;
				margin-bottom: 0.1rem;
				background: #fff;
				padding: 0.05rem;
			}

			p {
				color: #fff;
			}
		}
	}

	.page-2 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: .8rem 0;
		background: rgba(255, 255, 255, 0.5);

		.title {
			font-size: .3rem;
			padding: 0 0 .3rem 0;
			font-weight: 500;
		}

		.list {
			display: flex;
			width: 100vw;
			box-sizing: border-box;
			overflow-y: hidden;
			overflow-x: auto;
			margin-bottom: .4rem;
			padding-left: .78rem;
			padding-right: .32rem;

			.item {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 0 .4rem 0 0;

				h2 {
					text-align: center;
					font-size: .24rem;
					font-weight: 500;
					margin-bottom: 0.1rem;
					color: #CC99EA;
					font-weight: 500;
				}

				p {
					text-align: center;
					font-size: .16rem;
				}

				img {
					width: 2.4rem;
					height: auto;
				}
			}
		}

		.sub-title {
			font-size: .18rem;
			margin-bottom: .3rem;
		}

		.btn {
			font-size: .17rem;
			height: .5rem;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: .25rem;
			background: #BF90EF;
			padding: 0 .4rem;
			font-weight: 500;
			cursor: pointer;

			&:active {
				background: #FDF19D;
			}
		}
	}

	.list::-webkit-scrollbar {
		width: 0 !important
	}

	.page-3 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: .8rem 0;

		.title {
			font-size: .26rem;
			padding: 0 0 .3rem 0;
			font-weight: 500;
		}

		.list {
			display: flex;
			width: 100vw;
			box-sizing: border-box;
			overflow-y: hidden;
			overflow-x: auto;
			margin-bottom: .4rem;
			padding-left: .55rem;
			padding-right: .15rem;



			.item {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 0 .4rem 0 0;

				h2 {
					text-align: center;
					font-size: .22rem;
					font-weight: 500;
					margin-bottom: 0.1rem;
					color: #CC99EA;
					font-weight: 500;
				}

				.ball {
					width: 2.2rem;
					height: 2.2rem;
					border: #ccc 1px solid;
					border-radius: 50%;
					margin-bottom: 20px;
					padding: 0.3rem;
					display: flex;
					align-items: center;
					justify-content: center;
					background: none;

					img {
						width: 2.2rem;
						height: 2.2rem;
					}
				}

				.products {
					img {
						width: auto;
						height: .48rem;
					}
				}

			}
		}

		.btn {
			font-size: .17rem;
			height: .48rem;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: .30rem;
			padding: 0 .4rem;
			font-weight: 500;
			cursor: pointer;
			background: #BF90EF;

			&:active {
				background: #FDF19D;
			}
		}



	}

	.page-4 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: .8rem 0;
		background: rgba(255, 255, 255, 0.5);

		h2 {
			font-size: .24rem;
			margin-bottom: .4rem;
		}

		p {
			font-size: .16rem;
			margin-bottom: .1rem;

			&.sub {
				font-weight: 500;
				font-size: .2rem;
				padding: 0.2rem 0 0.2rem 0;
			}
		}

		img {
			width: 3rem;
			height: auto;
			margin-bottom: .3rem;
		}

		.btn {
			font-size: .17rem;
			height: .48rem;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: .30rem;
			padding: 0 .4rem;
			font-weight: 500;
			cursor: pointer;
			background: #BF90EF;

			&:active {
				background: #FDF19D;
			}
		}



	}


	.cover {
		position: fixed;
		z-index: 199;
		background: rgba(255, 255, 255, 0.1);
		left: 0;
		top: 0;
		width: 100vw;
		height: 100vh;
		backdrop-filter: blur(5px);
	}

	.about {
		position: fixed;
		z-index: 200;
		left: 50%;
		top: 50%;
		margin: -3.2rem 0 0 -1.7rem;
		background: #fff;
		width: 3.4rem;
		height: 6.4rem;
		box-shadow: rgba(0, 0, 0, 0.05) 0 0 40px;
		padding: .3rem;
		line-height: 1.6;
		box-sizing: border-box;

		h2 {
			color: #BF90EF;
			font-size: 24px;
			font-weight: normal;
		}

		.close {
			width: .24rem;
			height: .24rem;
			background: url('../assets/images/close.png') no-repeat;
			background-size: contain;
			position: absolute;
			right: .2rem;
			top: .2rem;
			cursor: pointer;

			&:active {
				opacity: 0.7;
			}
		}
	}

	.code {
		position: fixed;
		z-index: 200;
		left: 50%;
		top: 50%;
		margin: -2.4rem 0 0 -1.5rem;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 3rem;
		height: 3.6rem;
		box-shadow: rgba(0, 0, 0, 0.05) 0 0 40px;

		.close {
			width: .24rem;
			height: .24rem;
			background: url('../assets/images/close.png') no-repeat;
			background-size: contain;
			position: absolute;
			right: .2rem;
			top: .2rem;
			cursor: pointer;

			&:active {
				opacity: 0.7;
			}
		}

		p {
			font-size: 16px;
		}

		img {
			width: 2rem;
			height: 2rem;
			background: #ccc;
			margin-bottom: .2rem;
		}
	}
</style>
